<script setup>
  import IcInfo from "@/assets/images/svg-component/IcInfo.vue";
  import { computed, useAttrs } from "vue";

  const attrs = useAttrs();
  const props = defineProps({
    icon: {
      type: [Object, Function],
      default: IcInfo,
    },
  });
  const filteredAttrs = computed(() => {
    const { class: _c, style: _s, ...rest } = attrs;
    return rest;
  });
</script>

<template>
  <div class="helper-text" v-bind="filteredAttrs">
    <n-icon :size="16" class="mt-0.5" v-if="icon">
      <slot name="icon">
        <component :is="icon" />
      </slot>
    </n-icon>
    <p><slot></slot></p>
  </div>
</template>

<style lang="scss" scoped>
  .helper-text {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.25rem;
    color: var(--smoe-gray-600);
    font-weight: 400;
    font-size: 0.9375rem;
    line-height: 150%;
  }
</style>
